import { Grid2, styled, Typography } from '@mui/material'
import React from 'react'
import { AutoSizer, List, ListRowProps } from 'react-virtualized'

import Loader from '@/app/component/atom/loader'
import { Export } from '@/app/module/exports/types'

import ExportRow from './export-row'

type Props = {
  data: Export[]
  error: any
  loading: boolean

  onDelete: (exportId: number) => Promise<boolean>
  onFileDownload: (exportId: number, filename: string) => Promise<boolean>
}

const ROW_HEIGHT = 100

const ExportList: React.FC<Props> = ({ data, loading, onDelete, onFileDownload }) => {
  const renderRow = ({ index, key, style }: ListRowProps) => {
    const item = data[index]

    if (!item) {
      return null
    }

    return (
      <div key={key} style={style}>
        <ExportRow index={index} item={item} onDelete={onDelete} onFileDownload={onFileDownload} />
      </div>
    )
  }

  return (
    <Container id="export-list" data-testid="export-list" data-list-total={data.length}>
      <Header container>
        <Grid2 size={{ xs: 5 }} sx={{ px: 2, py: 1 }}>
          <Typography color="textSecondary" variant="subtitle1">
            File Name
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 2 }} sx={{ px: 2, py: 1 }}>
          <Typography color="textSecondary" variant="subtitle1">
            Type
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 2 }} sx={{ px: 2, py: 1 }}>
          <Typography color="textSecondary" variant="subtitle1">
            Created
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 2 }} sx={{ px: 2, py: 1 }}>
          <Typography color="textSecondary" variant="subtitle1">
            Status
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 1 }} sx={{ px: 2, py: 1 }}>
          <Typography color="textSecondary" variant="subtitle1">
            Actions
          </Typography>
        </Grid2>
      </Header>
      {!!data.length && (
        <ListContainer>
          <AutoSizer>
            {({ height, width }) => (
              <List
                className="export-list"
                height={height}
                width={width}
                rowCount={data.length + (loading ? 1 : 0)}
                rowHeight={ROW_HEIGHT}
                rowRenderer={renderRow}
              />
            )}
          </AutoSizer>
        </ListContainer>
      )}
      {!data.length && !loading && (
        <Typography variant="h6" color="textSecondary" align="center" sx={{ padding: 2 }}>
          No exports were found.
        </Typography>
      )}
      {loading && <Loader />}
    </Container>
  )
}

const Container = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
})

const Header = styled(Grid2)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderTop: `1px solid ${theme.palette.divider}`,
}))

const ListContainer = styled('div')({
  flex: 1,
  height: '100%',
})

export default ExportList
